import { render, staticRenderFns } from "./registerGYS.vue?vue&type=template&id=51a752fe&scoped=true"
import script from "./registerGYS.vue?vue&type=script&lang=js"
export * from "./registerGYS.vue?vue&type=script&lang=js"
import style0 from "./registerGYS.vue?vue&type=style&index=0&id=51a752fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a752fe",
  null
  
)

export default component.exports